export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./User.vue?vue&type=template&id=32590e1e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/header/User.vue?vue&type=template&id=32590e1e&scoped=true&
// module id = 887
// module chunks = 0